module.exports = __webpack_public_path__ + "static/frontUserNew/img/door-nav-unevaluated.d01a7856.png";